export default "__VITE_ASSET__agxm1Fy8__"